// @ts-nocheck
import React, { useCallback, useEffect } from "react";
import {
  Dialog,
  Drawer,
  List,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Clear";
import Propertylist from "./PropertyList";
import moment from "moment";
import { useOutletContext } from "react-router-dom";

export default function PropertyDrawer({
  isOpen,
  toggleSidebar,
  todaysProperties,
  selectedDate,
}) {
  // Callback ref to restore scroll position
  const scrollRef = useCallback((node) => {
    if (node && isOpen && selectedDate) {
      const key = `propertyDrawerScroll_${selectedDate}`;
      const saved = sessionStorage.getItem(key);
      if (saved) {
        node.scrollTop = parseInt(saved, 10);
      }
    }
  }, [isOpen, selectedDate, todaysProperties.length]);

  const handleclose = () => {
    toggleSidebar(false, moment(selectedDate).format("YYYY-DD-MM"));
  };

  const isMobile = useOutletContext();

  const handleScroll = (e) => {
    if (selectedDate) {
      const key = `propertyDrawerScroll_${selectedDate}`;
      sessionStorage.setItem(key, String(e.target.scrollTop));
    }
  };

  useEffect(() => {
    if (!isOpen) return;
    const timeout = setTimeout(() => {
      const node = document.querySelector('.MuiDrawer-paperAnchorRight') || document.querySelector('.MuiDrawer-paper');
      if (node) {
        node.addEventListener('scroll', handleScroll);
      }
    }, 0);

    return () => {
      clearTimeout(timeout);
      const node = document.querySelector('.MuiDrawer-paperAnchorRight') || document.querySelector('.MuiDrawer-paper');
      if (node) {
        node.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isOpen, selectedDate]);

  useEffect(() => {
    if (isOpen && selectedDate) {
      const key = `propertyDrawerScroll_${selectedDate}`;
      const saved = sessionStorage.getItem(key);
      if (saved) {
        let tries = 0;
        const maxTries = 20; // Try for up to 1 second (20 * 50ms)
        const desiredScroll = parseInt(saved, 10);

        function tryRestoreScroll() {
          const node = document.querySelector('.MuiDrawer-paperAnchorRight') || document.querySelector('.MuiDrawer-paper');
          if (node) {
            // Only restore if the content is tall enough
            if (node.scrollHeight - node.clientHeight >= desiredScroll || tries > maxTries) {
              node.scrollTop = desiredScroll;
            } else {
              tries++;
              setTimeout(tryRestoreScroll, 50);
            }
          }
        }

        tryRestoreScroll();
      }
    }
  }, [isOpen, selectedDate, todaysProperties.length]);

  const list = (p0?: string) => (
    <Box
      sx={{
        width: {
          xs: "100%", // For extra-small screens (mobile)
          sm: 400, // For small screens (tablets)
          md: 500, // For medium screens (desktops)
          lg: 650,
        },
        padding: 2,
      }}
      role="presentation"
    >
      <List
        ref={scrollRef}
        data-property-scroll
        sx={{ overflowY: "auto" }}
        onScroll={handleScroll}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{ fontWeight: 600, fontSize: isMobile ? "18px" : "22px", lineHeight: "39px" }}
          >
            {`Showing ${todaysProperties.length} properties for ${moment(
              selectedDate
            ).format("MMM D, YYYY")}`}
          </Typography>
          <div>
            <IconButton
              onClick={handleclose}
              sx={{
                "&:focus": {
                  outline: "none",
                },
                "&:focusVisible": {
                  outline: "none",
                },
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <CloseIcon
                sx={{
                  fontSize: { xs: "24px", sm: "28px" },
                  color: "#3B3B3B",
                }}
              />
            </IconButton>
          </div>
        </Box>
        <Propertylist
          todaysProperties={todaysProperties} />
      </List>
    </Box>
  );
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleclose}
      sx={{ zIndex: 1300, width: "650px" }}
      PaperProps={{
        'data-property-scroll': true,
        ref: scrollRef,
        sx: { overflowY: 'auto' }
      }}
    >
      {list("right")}
    </Drawer>
  );
}
